import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginTop: '8px'
    },
    header: {
      padding: '8px',
      textAlign: 'center',
      borderRadius: '4px'
    },
    body: {
      margin: '8px 0px'
    }
  })
);
